import { render, staticRenderFns } from "./RowsHeader.vue?vue&type=template&id=97651372&"
import script from "./RowsHeader.vue?vue&type=script&lang=js&"
export * from "./RowsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports